export default {
  name: 'InstructorClass',
  data() {
    return {
        tableData: [],
      fileList: [],
      //班级列表
      classlist: [
      ],
      //讨论区
      discuss: [
        { id: 1, name: '转换字体文字大小什么什么的', biaohao: '#333', day: 'opened Mar 13,2018', lll: 'by qooloop', pinglun: '2' },
        { id: 2, name: 'nodejs的api这么多，在学习的过程中应该如何有的放矢', biaohao: '#333', day: 'opened Mar 13,2018', lll: 'by qooloop', pinglun: '3' },
        // {id:3, name: '前端如何进阶全栈开发', biaohao: '#333', day: 'opened Mar 13,2018', lll: 'by qooloop', pinglun: '1'},
        // {id:4, name: 'typescript依赖注入实践', biaohao: '#333', day: 'opened Mar 13,2018', lll: 'by qooloop', pinglun: '2'},
        // {id:5, name: 'nodejs怎么学习啊?感觉资料很少啊', biaohao: '#333', day: 'opened Mar 13,2018', lll: 'by qooloop', pinglun: '0'},
        // {id:6, name: 'cnode這個論壇只用了一台服務器嗎', biaohao: '#333', day: 'opened Mar 13,2018', lll: 'by qooloop', pinglun: '8'},
        // {id:7, name: '前端如何进阶全栈开发', biaohao: '#333', day: 'opened Mar 13,2018', lll: 'by qooloop', pinglun: '1'},
        // {id:8, name: 'typescript依赖注入实践', biaohao: '#333', day: 'opened Mar 13,2018', lll: 'by qooloop', pinglun: '2'},
        // {id:9, name: '转换字体文字大小什么什么的', biaohao: '#333', day: 'opened Mar 13,2018', lll: 'by qooloop', pinglun: '2'},
        // {id:10, name: 'nodejs的api这么多，在学习的过程中应该如何有的放矢', biaohao: '#333', day: 'opened Mar 13,2018', lll: 'by qooloop', pinglun: '3'},
      ],
      // introduce: [
      //   {id: 1, classname: '班名:', title: '19计算机科学与技术1班', projectname: '项目名', title2: 'xxxxxxxxxxx', shopname: ''}
      // ]

      //成员列表
      MemberList: [
        // {
        //   id: '', 
        //   balance: '',
        //   class_id: '',
        //   company: '',
        //   email: '',
        //   id: '',
        //   name: '',
        //   phone: '',
        // },        
      ],

      //班级介绍
      introduction: {
        //选中班级名字
        name: "",
      },
      // 班级id
      id: '',
      // 是否增加下拉框的高度
      xiala: true,
      // 下拉文字切换
      xianshi: true,
      //搜索班级的名字
      classSreach: '',
      //班级公告
      bulletin: '',
      //学生名字
      username: '',
      id2: '',
      introduction2: {},
      //上传文件
      action: this.baseUrl + 'file/upload_class?token=' + this.$store.state.id,
      file: '',
      // 服务器返回的文件名字
      fileName: '',
      // 上传选择的文件名
      realName: '',
    }
  },
  methods: {

    //点击获取信息
    Clickdisplay1(banji) {
      this.projectDetails={
        period:banji.product_period,
        end_study_time:banji.project_end_study_time,
        end_time:banji.project_end_time,
        name:banji.project_name,
        onsale:banji.project_onsale,
        organizer:banji.project_organizer,
        sponsor:banji.project_sponsor,
        start_stydy_time:banji.project_start_stydy_time,
        start_time:banji.project_start_time
      }
      // 清理项目详情对象
      this.classDetails = {};
      this.id = banji.id;
      this.getstudentTwo(this.id);
      this.getClassinformation();
      

    },

    //获取成员列表
    getstudentTwo(index) {
      this.classIdFlag = index;
      this.$post('class_users/search', { token:this.$store.state.instructor, offset: 0, length: 500, class_id: index }).then(res => {
        // this.MemberListThree = res.data.result.data;
        // console.log('成员列表',res)
        this.tableData = res.data.result.data
      })
    },

    //跳转学生进度详情
    tostudentsmessage(row){
      // console.log('学生信息',row)
      const {href} = this.$router.resolve({
        path: '/studentsmessage',
        query: {
          purchasedId : row.purchased_id ,
          userId : row.id ,
          classId : row.class_id
        }
      })
      window.open(href, '_blank')
    },

    // 确认上传文件
    confirmUploadFile() {
      // 发送公告时判断简报和附件的内容是否为空，依次调用相应接口，内容空不调用接口
      // 接口class_bulletin/create为简报的接口
      // 接口class_file/create为附件的接口
      if (this.bulletin !== '' && this.fileName !== '') {
        this.$post('class_bulletin/create', { token: this.$store.state.instructor, class_id: this.id, bulletin: this.bulletin }).then(res => {
          if (res.data.status == 'success') {
            this.$message({
              showClose: true,
              message: '简报上传成功',
              type:'success'
            });
            // console.log('简报上传成功')
          }
          else{
            this.$message({
              showClose: true,
              message: '简报上传失败',
              type:'error'
            });
          }
        })
        this.$post('class_file/create', { token: this.$store.state.instructor, class_id: this.id, file_name: this.realName, file_as_name: this.fileName }).then(res => {
          if (res.data.status == 'success') {
            this.$message({
              showClose: true,
              message: '附件上传成功',
              type:'success'
            });
            // console.log('附件上传失败')
          }else{
            this.$message({
              showClose: true,
              message: '附件上传成功',
              type:'error'
            });
          }
        })
        UIkit.modal(document.querySelector('#modal-sendNotice')).hide();

      } else if (this.bulletin == '' && this.fileName !== '') {
        this.$post('class_file/create', { token: this.$store.state.instructor, class_id: this.id, file_name: this.realName, file_as_name: this.fileName }).then(res => {
          if (res.data.status == 'success') {
            this.$message({
              showClose: true,
              message: '附件上传成功',
              type:'success'
            });
            // console.log('附件上传成功')
          }
        })
        UIkit.modal(document.querySelector('#modal-sendNotice')).hide();
      } else if (this.bulletin !== '' && this.fileName == '') {
        this.$post('class_bulletin/create', { token: this.$store.state.instructor, class_id: this.id, bulletin: this.bulletin }).then(res => {
          // console.log(res)
          if (res.data.status == 'success') {
            this.$message({
              showClose: true,
              message: '简报上传成功',
              type:'success'
            });
            // console.log('简报上传成功')
          }
        })

        UIkit.modal(document.querySelector('#modal-sendNotice')).hide();
      }
      else {
        this.$message.error('简报和附件不能都为空');
      }
    },
    // 上传成功后返回的值
    handleSuccess(response, file, fileList) {
      this.fileName = response.result
      this.realName = file.name
    },
    // 限制上传文件个数的警告方法
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 5个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    //打开公告的界面
    sendNotice(id) {
      this.id = id;
      // console.log('id:'+id);
      // console.log('公告:'+this.introduction.name);
      if (this.id == '') {
        this.$message.error('请先选择班级');
      } else {
        // 清空简报、文件名、服务器返回的文件名和附件后显示窗口
        this.bulletin = '';
        this.realName = '';
        this.fileName = '';
        this.fileList = [];
        UIkit.modal(document.querySelector('#modal-sendNotice')).show();
      }

    },

    //关闭公告的界面
    cancel() {
      // console.log('关闭公告');
      UIkit.modal(document.querySelector('#modal-sendNotice')).hide();
    },


    //获取班级列表
    ClassInquiry() {
      this.$post('class/instructor_search', { token: this.$store.state.instructor, offset: 0, length: 40 }).then(res => {
        this.classlist = res.data.result.data
        // console.log(this.classlist[0].id);
        this.$post('class_users/search', { token:this.$store.state.instructor, offset: 0, length: 500, class_id: this.classlist[0].id }).then(res => {
          // this.MemberListThree = res.data.result.data;
          // console.log('成员列表',res)
          this.tableData = res.data.result.data
        })
        
      })
      // console.log(this.classlist[0].id);

    },

    //点击获取信息
    Clickdisplay(id, index) {
      this.id = id
      // this.getClassinformation()
      this.getstudent()
      if (this.$refs.light[index].style.background == '') {
        for (let i of this.$refs.light) {
          i.style.color = ''
          i.style.background = ''
        }
        this.$refs.light[index].style.background = '#1e87f1'
        this.$refs.light[index].style.color = '#ffffff'
      } else if (this.$refs.light[index].style.background != '') {
        this.$refs.light[index].style.background = '#1e87f1'
        this.$refs.light[index].style.color = '#ffffff'
      } else {
        this.$refs.light[index].style.background = ''
        this.$refs.light[index].style.color = ''
      }
    },


    //获取班级所有学生
    getstudent() {
      this.$post('class_users/search', { token:this.$store.state.instructor, offset: 0, length: 999, class_id: this.id }).then(res => {
        // console.log(res)
        this.MemberList = res.data.result.data
      })
    },


    //获取班级信息
    getClassinformation() {
      this.$post('class/get', { token: this.$store.state.instructor, id: this.id }).then(res => {
        // console.log(res);
        this.introduction = res.data.result;
        // console.log(this.introduction.name);
      })
    },

    //增加div高度
    Increase() {
      this.xiala = !this.xiala
      this.xianshi = !this.xianshi
      if (this.xiala == false) {
        document.getElementById('div1').style.height = 500 + 'px';
      } else {
        document.getElementById('div1').style.height = 200 + 'px';
      }
    },





  },

  mounted() {
    // console.log(this.classlist[0].id);
    this.ClassInquiry();
    // console.log(this.classlist);
    // this.$post('class_users/search', { token:this.$store.state.instructor, offset: 0, length: 999, class_id: this.classlist[0].id }).then(res => {
    //   // console.log(res)
    //   this.MemberList = res.data.result.data
    // })

  }

}